import { useTranslations } from "@jugl-web/utils";
import React from "react";
import formExampleImage from "../../assets/form-example.png";

export const HowItWorksTab: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-8">
      <section className="flex flex-col gap-3">
        <h3 className="font-secondary text-base font-semibold text-[#1A2023]">
          {t({
            id: "cx-ai-agents-page.collect-leads-how-instructions-title",
            defaultMessage: "Collect Leads instructions",
          })}
        </h3>
        <p className="font-secondary text-sm leading-[140%] text-dark-700">
          {t({
            id: "cx-ai-agents-page.collect-leads-how-instructions-body",
            defaultMessage:
              "Collect Leads form is an automated way to add your Customers to the Customers base. Set the instructions for the AI Agent, on when it should ask for the customer information. Here is the most popular scenarios to take in action:",
          })}
        </p>
        <ul className="m-0 list-disc pl-5 font-secondary text-sm leading-[140%] text-dark-700">
          <li>
            {t({
              id: "cx-ai-agents-page.collect-leads-how-scenario-escalation",
              defaultMessage:
                "When AI Agent escalates conversation to human agent",
            })}
          </li>
          <li>
            {t({
              id: "cx-ai-agents-page.collect-leads-how-scenario-booking",
              defaultMessage: "When customer wants to book a meeting",
            })}
          </li>
          <li>
            {t({
              id: "cx-ai-agents-page.collect-leads-how-scenario-order",
              defaultMessage: "When customer wants to place an order",
            })}
          </li>
        </ul>
      </section>
      <hr className="m-0 border-0 border-t border-solid border-dark-100" />
      <section className="flex flex-col gap-3">
        <h3 className="font-secondary text-base font-semibold text-[#1A2023]">
          {t({
            id: "cx-ai-agents-page.collect-leads-how-fields-title",
            defaultMessage: "Set Form Fields",
          })}
        </h3>
        <p className="font-secondary text-sm leading-[140%] text-dark-700">
          {t({
            id: "cx-ai-agents-page.collect-leads-how-fields-body",
            defaultMessage:
              "By the default, we recommend to ask for User Name, Email & Phone number. But you can always modify the fields you would like to ask your Customers. Please note that User Name is a mandatory field that is needed to add Customer to the Customers base.",
          })}
        </p>
      </section>
      <section className="flex flex-col gap-3">
        <span className="font-secondary text-sm leading-[140%] font-medium text-dark-800">
          {t({
            id: "cx-ai-agents-page.collect-leads-how-form-example-label",
            defaultMessage: "✨ Form Example:",
          })}
        </span>
        <img
          src={formExampleImage}
          alt={t({
            id: "cx-ai-agents-page.collect-leads-how-form-example-alt",
            defaultMessage: "Collect Leads form example",
          })}
          className="w-full"
        />
      </section>
    </div>
  );
};
